import { VisuallyHidden } from '@coop/components';
import { useEffect, useRef, useState } from 'react';

import { useA11yLogInConsoleEffect } from '../../hooks/useA11yLogInConsole';
import { useTemporaryTextEffect } from './A11yAnnouncer.hooks';

// Delays

/** when aria live is added first time to the DOM, itll not be read by the screen readers, hence we need to delay the first message so its picked up
 * @param a11yMessage - the message to be announced
 * @param delayFirstMessage - whether to delay the first message or not, this must be used if the a11yMessage is rendered on mount
 * @param name - name of the announcer for logging purposes
 */
const A11yAnnouncer = ({
    text,
    announcerName,
}: {
    text: string | undefined;
    announcerName: string;
}) => {
    const wasDelayed = useRef<boolean>(false);
    const [delayedMessage, setDelayedMessage] = useState<string | undefined>(undefined);
    useTemporaryTextEffect(delayedMessage, setDelayedMessage, 1000);
    useA11yLogInConsoleEffect(announcerName, delayedMessage);

    useEffect(() => {
        let timeout: NodeJS.Timeout | undefined;

        if (!wasDelayed.current) {
            timeout = setTimeout(() => {
                setDelayedMessage(text);
                wasDelayed.current = true;
            }, 500);
        } else {
            setDelayedMessage(text);
        }

        return () => {
            clearTimeout(timeout);
        };
    }, [text]);

    return <VisuallyHidden aria-live="polite">{text}</VisuallyHidden>;
};

export default A11yAnnouncer;
